import { Avatar, Box } from '@mui/material';
import { StoreResult } from 'api/client-domain/client-domain.types';
import StringAvatar from 'components/string-avatar/string-avatar.component';

type RelatedLocationAvatarProps = {
  relatedLocation: Partial<StoreResult>;
};

const size = {
  width: { xs: 40, sm: 80 },
  height: { xs: 40, sm: 80 },
};

const RelatedLocationAvatar = ({
  relatedLocation,
}: RelatedLocationAvatarProps) => {
  return (
    <Box position="relative">
      {relatedLocation?.smallImage ? (
        <Avatar
          alt=""
          src={relatedLocation?.smallImage}
          sx={{ boxShadow: 3, ...size }}
        />
      ) : (
        <StringAvatar
          name={relatedLocation?.title}
          showBgColor={false}
          sx={{ boxShadow: 3, ...size }}
        />
      )}
    </Box>
  );
};
export default RelatedLocationAvatar;
